<template>
  <div class="director-navbar" v-if="mostrarNavbar">
    <nav class="navbar navbar-expand-lg navbar-dark bg-danger">
      <div class="container-fluid">
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#directorNavContent"
          aria-controls="directorNavContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="directorNavContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'AdminUsuarios' }">
                <i class="fas fa-users-cog me-1"></i>AdminUsuarios
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/trabajosRealizados">
                <i class="fas fa-chart-line me-1"></i>TrabRealisados
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/Calculador">
                <i class="fas fa-calculator me-1"></i>Presupuestos
              </router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">
                <i class="fas fa-cogs me-1"></i>Configuración del Sistema
              </a>
            </li>
          </ul>
          <div class="d-flex">
            <span
              class="badge bg-light text-success me-2 d-flex align-items-center"
            >
              <i class="fas fa-crown me-1"></i>Modo Director
            </span>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "DirectorNavbar",
  data() {
    return {
      usuario: null,
      mostrarNavbar: false,
    };
  },
  created() {
    // Verificar si hay un usuario en localStorage al cargar el componente
    this.verificarUsuario();
    // Escuchar cambios desde otras pestañas
    window.addEventListener("storage", this.verificarUsuario);
    // Escuchar un evento personalizado para cambios locales
    window.addEventListener("usuario-cambiado", this.verificarUsuario);
  },
  beforeUnmount() {
    // Eliminar los listeners al desmontar el componente
    window.removeEventListener("storage", this.verificarUsuario);
    window.removeEventListener("usuario-cambiado", this.verificarUsuario);
  },
  watch: {
    // Re-verificar al cambiar de ruta (p.ej., tras login redirige a home)
    $route() {
      this.verificarUsuario();
    },
  },
  methods: {
    verificarUsuario() {
      const usuarioGuardado = localStorage.getItem("usuario");
      if (usuarioGuardado) {
        try {
          this.usuario = JSON.parse(usuarioGuardado);
          // Solo mostrar el navbar si el usuario es Director
          this.mostrarNavbar =
            (this.usuario.categoria || "").trim().toLowerCase() === "director";
        } catch (e) {
          this.usuario = null;
          this.mostrarNavbar = false;
          localStorage.removeItem("usuario");
        }
      } else {
        this.usuario = null;
        this.mostrarNavbar = false;
      }
    },
  },
};
</script>

<style scoped>
.director-navbar {
  margin-top: 76px; /* Ajustar según la altura del navbar principal */
  position: sticky;
  top: 76px;
  z-index: 999;
}

.navbar-dark.bg-danger {
  background-color: #01ac15 !important;
}

.nav-link {
  color: rgba(255, 255, 255, 0.9) !important;
}

.nav-link:hover {
  color: #fff !important;
}

/* Estilos para pantallas pequeñas */
@media (max-width: 991px) {
  .director-navbar {
    margin-top: 56px; /* Ajustar para navbar más pequeño en móviles */
    top: 56px;
  }
}
</style>
